import * as rive from "@rive-app/canvas";
import escape from "./helpers/escape.js";

const button = document.querySelector(".demo-button");
const buttonLeft = document.querySelector(".button-action-left");
const buttonRight = document.querySelector(".button-action-right");
const buttonBunnyLeft = document.querySelector(".button-action-bunny-left");
const buttonBunnyRight = document.querySelector(".button-action-bunny-right");
const r = new rive.Rive({
  src: "rive/card_flip_bunny_test_2.riv",
  canvas: document.querySelector("canvas"),
  autoplay: true,
  stateMachines: "State Machine 1",
  fit: rive.Fit.cover,
  onLoad: (_) => {
    const inputs = r.stateMachineInputs("State Machine 1");
    const right = inputs.find((i) => i.name === "right");
    const left = inputs.find((i) => i.name === "left");
    const buttons = [left, right];
    const rightBunny = inputs.find((i) => i.name === "right rabbit");
    const leftBunny = inputs.find((i) => i.name === "left rabbit");
    const resetRabbits = () => {
      leftBunny.value = rightBunny.value = false;
    };
    const resetToDefault = (btnIdx) => {
      if (!isFlipping) {
        isFlipping = true;
        right.value = left.value = false;
        buttons[btnIdx].value = true;
      } else {
        isFlipping = false;
        right.value = false;
        left.value = false;
      }
    };
    const random = () => Math.random() < 0.2;
    // initial state
    let isFlipping = true;
    left.value = true;

    const flipToTheRight = () => {
      resetRabbits();
      if (isFlipping && right.value) {
        // is flipping from right? stop flipping
        right.value = false;
        isFlipping = false;
        leftBunny.value = random() ? true : false;
        left.value = leftBunny.value;
      } else if (isFlipping && left.value) {
        // is flipping from left? keep flipping, but from right
        left.value = false;
        right.value = true;
        isFlipping = true;
      } else {
        resetToDefault(1);
      }
    };

    const flipToTheLeft = () => {
      resetRabbits();
      if (isFlipping && left.value) {
        // is flipping from left? stop flipping
        left.value = false;
        isFlipping = false;
        rightBunny.value = random() ? true : false;
        right.value = rightBunny.value;
      } else if (isFlipping && right.value) {
        // is flipping from right? keep flipping, but from left
        right.value = false;
        left.value = true;
        isFlipping = true;
      } else {
        resetToDefault(0);
      }
    };

    buttonBunnyRight.onclick = () => {
      rightBunny.value = true;
      leftBunny.value = false;
    };
    buttonBunnyLeft.onclick = () => {
      rightBunny.value = false;
      leftBunny.value = true;
    };

    buttonRight.onclick = flipToTheRight;
    buttonLeft.onclick = flipToTheLeft;
    document.onkeyup = (e) => {
      console.log("keyup", e.code);
      e.preventDefault();
      ["Space", "ShiftRight"].includes(e.code) && flipToTheLeft();
      ["ShiftLeft"].includes(e.code) && flipToTheRight();
    };
  },
  onStateChange: (event) => {
    console.log(event.data);
  },
});

escape("menu.html");